import { createContext, useContext, type ReactNode } from "react";
import { LiveConfig, LIVE } from "@/data/live";
import { useLiveData } from "@/hooks/useLiveData";

const LiveDataContext = createContext<LiveConfig>(LIVE);

export function LiveDataProvider({ children }: { children: ReactNode }) {
  const liveData = useLiveData();
  return <LiveDataContext.Provider value={liveData}>{children}</LiveDataContext.Provider>;
}

/**
 * Use this hook in any component that needs live election data.
 * Returns a LiveConfig object that auto-refreshes from the database.
 */
export function useLive(): LiveConfig {
  return useContext(LiveDataContext);
}
